export const INVALID_DATE = 'Invalid Date';

export const fullDateFormatter = (date: string): string => {
  // 2023-01-29T01:00:00Z
  const parsedDate = new Date(date);

  if (parsedDate.toString() === INVALID_DATE) {
    throw new Error(INVALID_DATE);
  }

  const year = pad(parsedDate.getFullYear().toString());
  const month = pad((parsedDate.getMonth() + 1).toString());
  const day = pad(parsedDate.getDate().toString());

  const hour = pad(parsedDate.getHours().toString());
  const minutes = pad(parsedDate.getMinutes().toString());

  return `${day}/${month}/${year.substring(2)} ${hour}:${minutes}`;
};

const pad = (str: string): string => {
  if (str.length === 1) {
    return `0${str}`;
  }

  return str;
};
export const shortDateFormatter = (date: string): string => {
  // 2023-01-29T01:00:00Z
  const parsedDate = new Date(date);

  if (parsedDate.toString() === INVALID_DATE) {
    throw new Error(INVALID_DATE);
  }

  const month = pad((parsedDate.getMonth() + 1).toString());
  const day = pad(parsedDate.getDate().toString());

  return `${day}/${month} `;
};
export const hourFormatter = (date: string): string => {
  // 2023-01-29T01:00:00Z
  const parsedDate = new Date(date);

  if (parsedDate.toString() === INVALID_DATE) {
    throw new Error(INVALID_DATE);
  }

  const hour = pad(parsedDate.getHours().toString());
  const minutes = pad(parsedDate.getMinutes().toString());
  return `${hour}:${minutes}`;
};
